export class Location {
    locationId: number = 0;
    locationCode: string = '';
    locationName: string = '';
    city: string = '';
}
